<template>
    <div class="sustainable-component wage-result-totaloverview">
        <!--
    <div class="bg-success mb-3 p-3 rounded">vue wage-result-totaloverview</div>
    -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-6">

                    <table class="table table-light table-hover table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th class="col-2">Befattning</th>
                                <th class="col-2">GLD</th>
                                <th class="col-2">BLD max</th>
                                <th class="col-2">ILD max</th>
                                <th class="col-2">RLD max</th>
                                <th class="col-2">Summa</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(overView, index) in totalWageOverviews" :key="index">
                                <td>{{overView.JobPositionName}}</td>
                                <td><span v-decimal-text.max2="overView.BaseSalary"></span></td>
                                <td><span v-decimal-text.max2="overView.MaxBlockSalary"></span></td>
                                <td><span v-decimal-text.max2="overView.MaxIndividualSalary"></span></td>
                                <td><span v-decimal-text.max2="overView.MaxDynamicSalary"></span></td>
                                <td><span v-decimal-text.max2="overView.SumSalaryParts"></span></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="col-6">
                    <table cellspacing="0" cellpadding="5" border="0">
                        <tr style="background-color:#4B6FB2; color: White">
                            <td class="px-3 py-2">Teoretiskt max:</td>
                            <td class="px-3 py-2" align="right"><span v-decimal-text.max2="TeoreticalMax"></span></td>
                        </tr>
                        <tr style="background-color: #ABC32E; color: Black">
                            <td class="px-3 py-2">RLD max:</td>
                            <td class="px-3 py-2" align="right"><span v-decimal-text.max2="RLDmax"></span></td>
                        </tr>
                        <tr style="background-color:#C0C0C0;color:Black">
                            <td class="px-3 py-2">
                                ILD max:
                            </td>
                            <td class="px-3 py-2" align="right"><span v-decimal-text.max2="ILDmax"></span></td>
                        </tr>
                        <tr style="background-color:#CE6E26; color: Black">
                            <td class="px-3 py-2">
                                BLD max:
                            </td>
                            <td class="px-3 py-2" align="right"><span v-decimal-text.max2="BLDmax"></span></td>
                        </tr>
                        <tr style="background-color: #630C78; color: white ">
                            <td class="px-3 py-2">
                                GLD max:
                            </td>
                            <td class="px-3 py-2" align="right"><span v-decimal-text.max2="GLDmax"></span></td>
                        </tr>
                        <tr style="background-color:#630C78; color: white">
                            <td class="px-3 py-2">
                                GLD min:
                            </td>
                            <td class="px-3" align="right"><span v-decimal-text.max2="GLDMin"></span></td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-result-totaloverview',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async loadOverviews() {
                this.loading++;
                try {
                    this.totalWageOverviews = await WageService.getTotalWageOverview();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadMaxWageParts() {
                this.loading++;
                try {
                    this.maxWageParts = await WageService.getMaxWageparts();
                    this.GLDMin = this.maxWageParts[0].MinBaseSalary;
                    this.GLDmax = this.maxWageParts[0].MaxBaseSalary;
                    this.BLDmax = this.maxWageParts[0].MaxBlockSalary;
                    this.ILDmax = this.maxWageParts[0].MaxIndividualSalary;
                    this.RLDmax = this.maxWageParts[0].MaxDynamicSalary;
                    this.TeoreticalMax = this.maxWageParts[0].MinBaseSalary + this.maxWageParts[0].MaxBlockSalary + this.maxWageParts[0].MaxIndividualSalary + this.maxWageParts[0].MaxDynamicSalary
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                totalWageOverviews: [],
                maxWageParts: [],
                GLDMin: null,
                GLDmax: null,
                BLDmax: null,
                ILDmax: null,
                RLDmax: null,
                TeoreticalMax: null,
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.loadOverviews();
            this.loadMaxWageParts();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
